window.ProductGallerySelection = Object.freeze({
  groupForColor(groups, color) {
    return groups.find(group => group.optionValue === color || group.label === color);
  },
  groupedMediaIds(groups, color, mediaIds) {
    const group = this.groupForColor(groups, color);
    const available = new Set(mediaIds.map(String));
    return (group?.mediaIds || []).map(String).filter(id => available.has(id));
  },
  mediaIdsForColor(groups, color, mediaIds) {
    const grouped = this.groupedMediaIds(groups, color, mediaIds);
    return grouped.length ? grouped : mediaIds.map(String);
  }
});
